'use client';

import classNames from 'classnames';
import { SliceZone } from '@prismicio/react';

import { Box } from '@preventx/oxygen';

// Types
import { ISOLanguageKeys } from '@/types/language';
import { DropdownPanelSection } from '@/types/navigation/panel';
import { SiteNavigationSliceContext } from '@/types/contexts/sliceZoneContext';

// Slices
import { components as sharedComponents } from '@/slices/shared';
import { components as navigationComponents } from '@/slices/navigation';
import { components as advertisementsComponents } from '@/slices/advertisements';
import { RefObject } from 'react';

type SectionProps = {
  id: string;
  isNavigationDrawer: boolean;
  section: DropdownPanelSection;
  language: string | ISOLanguageKeys;
  ref: RefObject<HTMLDivElement | null>;
};

export const Section = ({
  id,
  ref,
  section,
  language,
  isNavigationDrawer,
}: SectionProps) => {
  const sectionId = `section-identifier-${id}`;

  const { sectionType, slices } = section;

  const sliceContext: SiteNavigationSliceContext = {
    ref: ref,
    id: sectionId,
    lang: language,
    type: 'layout',
    isNavigationDrawer: isNavigationDrawer,
  };

  return (
    <Box
      addFlow
      component="section"
      aria-labelledby={sectionId}
      className={classNames({
        dropdown__feature: sectionType === 'Feature',
        dropdown__content: sectionType === 'Content',
      })}
    >
      <SliceZone
        slices={slices}
        context={sliceContext}
        components={{
          ...sharedComponents,
          ...navigationComponents,
          ...advertisementsComponents,
        }}
      />
    </Box>
  );
};
